import { render, staticRenderFns } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=1fb73196&scoped=true&"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js&"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyAskedQuestions.vue?vue&type=style&index=0&id=1fb73196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb73196",
  null
  
)

component.options.__file = "FrequentlyAskedQuestions.vue"
export default component.exports